<div
  class="gd-form-select-location-single-v2">

  <!-- Input data -->
  <mat-form-field
    *ngIf="!viewOnly; else viewOnlyTemplate"
    appearance="outline">

    <!-- Place holder -->
    <mat-label
      *ngIf="!neverFloatLabel">
      {{ placeholder | translate }}
    </mat-label>

    <!-- Select -->
    <mat-select
      [(ngModel)]="value"
      (closed)="onTouchItem()"
      [errorStateMatcher]="errMatcher"
      [disabled]="disabled"
      [required]="required"
      [placeholder]="neverFloatLabel ? (placeholder | translate) : undefined"
      panelClass="gd-form-select-location-single-v2-panel"
      (click)="vScrollToFirstSelectedOption()"
      (opened)="vScrollToFirstSelectedOption()"
      (ngModelChange)="updateSelected(true)">

      <!-- Search filter -->
      <mat-option>
        <!-- Search option -->
        <ngx-mat-select-search
          [(ngModel)]="searchValue"
          [placeholderLabel]="'LNG_SEARCH_LOCATIONS_AUTO_COMPLETE_TYPE_TO_SEARCH_TEXT' | translate"
          [noEntriesFoundLabel]="locationLoading ? undefined : currentNotFoundText | translate:notFoundTextData"
          [clearSearchInput]="false"
          [disableScrollToActiveOnOptionsChanged]="true"
          [preventHomeEndKeyPropagation]="true"
          [searching]="locationLoading"
          (ngModelChange)="search()">
        </ngx-mat-select-search>
      </mat-option>

      <!-- vscroll -->
      <cdk-virtual-scroll-viewport
        #cdkVirtualScrollViewport
        [itemSize]="40"
        [minBufferPx]="240"
        [maxBufferPx]="480"
        style="height: 20rem; overflow-x: hidden;">

        <!-- Empty option used to select nothing -->
        <mat-option
          *ngIf="clearable"
          [value]="null">
          {{ 'LNG_COMMON_LABEL_NONE' | translate }}
        </mat-option>

        <!-- Options -->
        <mat-option
          *cdkVirtualFor="let location of locations; templateCacheSize: 0"
          [value]="location.id"
          [disabled]="location.disabled">
          <span
            [style.padding-left]="(location.level * 30) + 'px'"
            [innerHTML]="location.label | highlight:searchValue">
          </span>
        </mat-option>

      </cdk-virtual-scroll-viewport>

      <!-- Selected option(s) hack to handle not visible in virtual scroll options -->
      <ng-container
        *ngIf="value && selectedLocation">

        <!-- Options -->
        <mat-option
          style="height: 0; display: none;"
          [value]="selectedLocation.id">
          <!-- Label -->
          {{selectedLocation.label}}
        </mat-option>

      </ng-container>

    </mat-select>

    <!-- Spinner -->
    <mat-progress-spinner
      *ngIf="locationLoading"
      matSuffix
      diameter="16"
      mode="indeterminate"
      color="primary">
    </mat-progress-spinner>

    <!-- Errors -->
    <mat-error
      *ngIf="control?.invalid && control?.touched">
      {{ getErrorMessages() }}
    </mat-error>

  </mat-form-field>

  <!-- View only -->
  <ng-template
    #viewOnlyTemplate>
    <div
      fxLayout="row" fxLayoutGap="1.6rem"
      class="gd-form-select-location-single-v2-viewonly">
      <!-- Label -->
      <div
        class="gd-form-select-location-single-v2-viewonly-label">
        {{ placeholder | translate }}:
      </div>

      <!-- Value -->
      <div
        class="gd-form-select-location-single-v2-viewonly-value">
        {{selectedLocation ? selectedLocation.label : noValueLabel}}
      </div>
    </div>
  </ng-template>
</div>
